import type { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { Color, Text } from "src/elements";
import styled from "styled-components";

const ShelfName = styled(Text)`
  position: absolute;
  top: -5px;
  left: 0;
  padding-left: 8px;
  font-size: 10px;
  color: ${Color.white};
`;

type ShelfLabelTranslation = (key: string, options?: Record<string, string | number>) => string;

export const getShelfLabel = (
  shelf: Pick<PlanogramShelf, "getNo" | "getName" | "getNotchNo">,
  shelfLabelBayNo?: number,
  t?: ShelfLabelTranslation,
) => {
  const notchSuffix = t
    ? t("shelfNotchPrefix", { notch: shelf.getNotchNo() })
    : ` N:${shelf.getNotchNo()}`;

  if (typeof shelfLabelBayNo === "number") {
    return `${shelfLabelBayNo}.${shelf.getNo()}${notchSuffix}`;
  }

  return `${shelf.getName()}${notchSuffix}`;
};

interface Props {
  shelf: Pick<PlanogramShelf, "getNo" | "getName" | "getNotchNo">;
  shelfLabelBayNo?: number;
  t: ShelfLabelTranslation;
  testId?: string;
  className?: string;
}

export const ShelfLabel = ({ shelf, shelfLabelBayNo, t, testId, className }: Props) => (
  <ShelfName className={className} color={Color.white} variant="caption1" testId={testId}>
    {t("shelf")}: {getShelfLabel(shelf, shelfLabelBayNo, t)}
  </ShelfName>
);
